import { useState } from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa";
import { HiOutlineMenuAlt1 } from "react-icons/hi";
import { IoIosClose } from "react-icons/io";
import one1 from "../src/assets/01.png";
import one2 from "../src/assets/02.png";
import one3 from "../src/assets/03.png";
import one4 from "../src/assets/04.png";
import one5 from "../src/assets/05.png";
import one6 from "../src/assets/06.png";
import one from "../src/assets/1.png";
import two from "../src/assets/2.png";
import three from "../src/assets/3.png";
import four from "../src/assets/4.png";
import about from "../src/assets/phone.png";
import abouts from "../src/assets/abouts1.png";
import video from "../src/assets/bg-video.mp4";
import bgImage from "../src/assets/bg.jpg";
import bluelogo from "../src/assets/blue-logo.png";
import D1 from "../src/assets/D1.jpg";
import D2 from "../src/assets/D2.jpg";
import D3 from "../src/assets/D3.jpg";
import gps from "../src/assets/finish.png";
import legal1 from "../src/assets/wave2.png";
import legal from "../src/assets/justice.png";
import gps1 from "../src/assets/wave3.png";
import logo from "../src/assets/SHORELINELOGO.png";
import sub from "../src/assets/sub.jpg";
import wave from "../src/assets/wave.png";
import wave1 from "../src/assets/wave1.png";
import app from "../src/assets/appstore.png";
import play from "../src/assets/google.png";
import check from "../src/assets/check-circle 1.png";

import "./App.scss";
import { CiLocationArrow1 } from "react-icons/ci";

export default function App() {
  //smoth. scrolling
  const handleSmoothScroll = (e) => {
    e.preventDefault();
    const targetId = e.currentTarget.getAttribute("href");
    const targetElement = document.querySelector(targetId);
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    }
  };
  // call handleSmoothScroll on all anchor tags
  const anchorTags = document.querySelectorAll("a[href^='#']");
  anchorTags.forEach((anchor) => {
    anchor.addEventListener("click", handleSmoothScroll);
  });

  const faqData = [
    {
      question: "What is the purpose of Shoreline Defender?",
      answer:
        "Shoreline Defender empowers public access rights and educates beachgoers about lawful use of shorelines.",
    },
    {
      question: "How does the app measure tide levels?",
      answer:
        "It uses GPS data and NOAA tide station feeds to calculate tide lines relevant to your location.",
    },
    {
      question: "Is the app easy to use for all beach visitors?",
      answer:
        "Yes, the app is designed to be user-friendly and intuitive, ensuring all beach visitors, regardless of tech-savviness, can easily access tide information, safety alerts, and location details for a smooth, hassle-free experience.",
    },
    {
      question: "Can I manually search for a beach?",
      answer:
        "Absolutely. You can search by name, state, or use the map view for manual beach lookup.",
    },
    {
      question: "What should I do if I find a violation or safety concern?",
      answer:
        "Submit a report through the app, including photos or details. Your report helps support enforcement and advocacy.",
    },
  ];
  const cardData = [
    {
      title: "Report a Dispute",
      linkText: "Turn Every Violation Into Evidence",
      description:
        "If you were confronted, harassed, or told to leave public land—submit a report.",
      image: D1,
    },
    {
      title: "Advocacy",
      linkText: "This Isn’t Just a Beach Issue",
      description:
        "Across the country, coastal access is eroding—not from storms, but from power grabs.",
      image: D2,
    },
    {
      title: "Beach Safety",
      linkText: "Beach Smart. Beach Safe. Beach Aware.",
      description:
        "We built to protect your rights. But we also believe in protecting your life, and your family.",
      image: D3,
      link: "https://www.visitsouthwalton.com/beach-safety/",
    },
  ];
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <div>
      <section className="hero">
        <video
          className="hero__video"
          src={video}
          autoPlay
          muted
          loop
          playsInline
        />

        <div className="hero__overlay" />

        <div className="hero__content container" id="home">
          <div className="hero__navbar">
            <img src={logo} alt="Shoreline Defender" className="hero__logo" />

            <button
              className="hero__toggle"
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Toggle menu"
            >
              <HiOutlineMenuAlt1 size={25} />
            </button>

            {/* Overlay */}
            {menuOpen && (
              <div
                className="hero__overlay"
                onClick={() => setMenuOpen(false)}
              />
            )}
            <nav className={`hero__nav ${menuOpen ? "open" : ""}`}>
              <a href="#how-it-works">How It Works</a>
              <a href="#about">About</a>
              {/* <a href="#report">Report a Dispute</a>
              <a href="#advocacy">Advocacy</a> */}
              <a
                href="https://www.visitsouthwalton.com/beach-safety/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Beach Safety
              </a>
            </nav>
            {/* Animated Drawer */}
            <nav className={`hero__nav-drawer ${menuOpen ? "open" : ""}`}>
              <div className="small-logo">
                <img
                  src={logo}
                  alt="Shoreline Defender"
                  className="hero__logo-drawer"
                />
                <IoIosClose
                  onClick={() => setMenuOpen(false)}
                  className="close-icon"
                />
              </div>

              <a onClick={() => setMenuOpen(false)} href="#how-it-works">
                How It Works
              </a>
              <a onClick={() => setMenuOpen(false)} href="#about">
                About
              </a>
              <a onClick={() => setMenuOpen(false)} href="#report">
                Report a Dispute
              </a>
              <a onClick={() => setMenuOpen(false)} href="#advocacy">
                Advocacy
              </a>
              <a
                onClick={() => setMenuOpen(false)}
                href="https://www.visitsouthwalton.com/beach-safety/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Beach Safety
              </a>
            </nav>

            <button className="hero__contact">
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="21"
                  viewBox="0 0 20 21"
                  fill="none"
                >
                  <g clip-path="url(#clip0_485_1894)">
                    <path
                      d="M17.5 3.42294H15V2.58961C15 1.21127 13.8783 0.0896072 12.5 0.0896072H2.5C1.12167 0.0896072 0 1.21127 0 2.58961V14.9679C0 15.6296 0.3625 16.2346 0.945 16.5463C1.21 16.6888 1.50083 16.7588 1.79083 16.7588C2.1375 16.7588 2.48333 16.6579 2.7825 16.4588L5 14.9804V17.5896H13.9142L17.2175 19.7929C17.5167 19.9921 17.8625 20.0929 18.2092 20.0929C18.4992 20.0929 18.7892 20.0221 19.055 19.8796C19.6375 19.5671 20 18.9621 20 18.3013V5.92294C20 4.54461 18.8783 3.42294 17.5 3.42294ZM1.85833 15.0721C1.8425 15.0821 1.79667 15.1121 1.73167 15.0779C1.66583 15.0429 1.66583 14.9871 1.66583 14.9688V2.58961C1.66583 2.12961 2.04 1.75627 2.49917 1.75627H12.4992C12.9592 1.75627 13.3325 2.12961 13.3325 2.58961V12.5896H5.58083L1.85833 15.0721ZM18.3333 18.3021C18.3333 18.3196 18.3333 18.3763 18.2683 18.4113C18.2017 18.4471 18.1567 18.4163 18.1417 18.4054L14.4192 15.9229H6.66667V14.2563H15V5.08961H17.5C17.96 5.08961 18.3333 5.46294 18.3333 5.92294V18.3021ZM6.66667 5.92294H5C5 5.18211 5.32583 4.48377 5.89333 4.00711C6.46083 3.53044 7.2075 3.32877 7.94583 3.46294C8.95333 3.63877 9.7825 4.46711 9.96 5.47711C10.1458 6.53711 9.64167 7.59627 8.705 8.11377C8.3325 8.31877 8.3325 8.37877 8.3325 8.42294H6.66583C6.66583 7.33294 7.53083 6.85711 7.9 6.65377C8.14167 6.52127 8.39583 6.20794 8.31833 5.76544C8.26083 5.43877 7.98333 5.16127 7.6575 5.10461C7.4025 5.05794 7.15583 5.12294 6.96417 5.28461C6.77417 5.44294 6.66583 5.67627 6.66583 5.92377L6.66667 5.92294ZM6.66667 9.25627H8.33333V10.9229H6.66667V9.25627Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_485_1894">
                      <rect
                        width="20"
                        height="20"
                        fill="white"
                        transform="translate(0 0.0896072)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              CONTACT
            </button>
          </div>

          <h1>America's #1 Shoreline Rights Platform</h1>
          <p>The Clear Sky of Public Beach Access.</p>

          <div className="hero__buttons">
            <button
              className="btn btn-primary"
              onClick={() =>
                (window.location.href =
                  "https://apps.apple.com/in/app/shoreline-defender-app/id6746795586")
              }
            >
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="21"
                  viewBox="0 0 20 21"
                  fill="none"
                >
                  <g clip-path="url(#clip0_485_1860)">
                    <path
                      d="M19.1667 20.5H0.833333C0.375 20.5 0 20.125 0 19.6667C0 19.2083 0.375 18.8333 0.833333 18.8333H19.1667C19.625 18.8333 20 19.2083 20 19.6667C20 20.125 19.625 20.5 19.1667 20.5ZM12.3083 16.2167L17.6 10.5917C18.325 9.86667 18.5333 8.83333 18.1417 7.89167C17.75 6.95 16.875 6.35833 15.85 6.35H14.125L14.1 3.80833C14.1 1.98333 12.6167 0.5 10.7917 0.5H9.14167C7.31667 0.5 5.83333 1.98333 5.83333 3.81667V6.33333H4.125C3.1 6.33333 2.225 6.925 1.83333 7.875C1.44167 8.81667 1.65 9.85833 2.35833 10.5583L7.63333 16.225C8.275 16.8667 9.125 17.1917 9.975 17.1917C10.825 17.1917 11.6667 16.8667 12.3167 16.225L12.3083 16.2167ZM6.66667 8C6.89167 8 7.1 7.90833 7.25833 7.75833C7.41667 7.6 7.5 7.39167 7.5 7.16667V3.80833C7.5 2.9 8.23333 2.16667 9.14167 2.16667H10.7917C11.7 2.16667 12.4333 2.90833 12.4333 3.81667L12.4583 7.19167C12.4583 7.65 12.8333 8.01667 13.2917 8.01667H15.8333C16.3417 8.01667 16.5417 8.40833 16.5833 8.525C16.6333 8.64167 16.7667 9.05833 16.3833 9.43333L11.1083 15.0417C10.4667 15.675 9.43333 15.6667 8.81667 15.05L3.54167 9.38333C3.18333 9.025 3.31667 8.60833 3.36667 8.49167C3.41667 8.375 3.61667 7.98333 4.11667 7.98333H6.66667V8Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_485_1860">
                      <rect
                        width="20"
                        height="20"
                        fill="white"
                        transform="translate(0 0.5)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              DOWNLOAD THE APP
            </button>
            {/* <button className="btn btn-outline">
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="21"
                  viewBox="0 0 20 21"
                  fill="none"
                >
                  <g clip-path="url(#clip0_485_1867)">
                    <path
                      d="M10 0.5C4.48583 0.5 0 4.98583 0 10.5C0 16.0142 4.48583 20.5 10 20.5C15.5142 20.5 20 16.0142 20 10.5C20 4.98583 15.5142 0.5 10 0.5ZM6.66667 18.1367V18C6.66667 16.1617 8.16167 14.6667 10 14.6667C11.8383 14.6667 13.3333 16.1617 13.3333 18V18.1367C12.3117 18.5842 11.185 18.8333 10 18.8333C8.815 18.8333 7.68833 18.5842 6.66667 18.1367ZM14.9375 17.2092C14.5575 14.8267 12.4883 13 10 13C7.51167 13 5.44333 14.8267 5.0625 17.2092C3.00417 15.69 1.66667 13.2483 1.66667 10.5C1.66667 5.905 5.405 2.16667 10 2.16667C14.595 2.16667 18.3333 5.905 18.3333 10.5C18.3333 13.2483 16.9958 15.69 14.9375 17.2092ZM10 4.66667C8.16167 4.66667 6.66667 6.16167 6.66667 8C6.66667 9.83833 8.16167 11.3333 10 11.3333C11.8383 11.3333 13.3333 9.83833 13.3333 8C13.3333 6.16167 11.8383 4.66667 10 4.66667ZM10 9.66667C9.08083 9.66667 8.33333 8.91917 8.33333 8C8.33333 7.08083 9.08083 6.33333 10 6.33333C10.9192 6.33333 11.6667 7.08083 11.6667 8C11.6667 8.91917 10.9192 9.66667 10 9.66667Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_485_1867">
                      <rect
                        width="20"
                        height="20"
                        fill="white"
                        transform="translate(0 0.5)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              JOIN THE MOVEMENT
            </button> */}
          </div>
        </div>

        <div className="hero__features">
          <div className="">
            <div className="d-flex align-items-center">
              <img src={wave} alt="" className="d-none" />
              <img src={wave1} alt="" className="res-d-block" />
            </div>

            <p>
              Powered by <strong>proprietary geospatial models</strong> and{" "}
              <strong>verified public data.</strong>
            </p>
          </div>
          <div className="">
            <div className="d-flex align-items-center">
              <img src={gps} alt="" className="d-none" />
              <img src={gps1} alt="" className="res-d-block" />
            </div>
            <p>
              Calculated to the foot with{" "}
              <strong>GPS and NOAA elevation benchmarks.</strong>
            </p>
          </div>
          <div className="">
            <div className="d-flex align-items-center">
              <img src={legal} alt="" className="d-none" />
              <img src={legal1} alt="" className="res-d-block" />
            </div>
            <p>
              Architected to withstand{" "}
              <strong>legal scrutiny, citizen disputes,</strong> and{" "}
              <strong>enforcement standards.</strong>
            </p>
          </div>
        </div>
      </section>
      <section className="how-it-works" id="how-it-works">
        <div className="how-it-works__image">
          <img src={about} alt="Shoreline Defender App" />
        </div>

        <div className="how-it-works__content">
          <h2>How It Works</h2>

          <div className="how-it-works__steps">
            {/* Step 1 */}
            <div className="step">
              <img src={one} alt="Set Start Point" />
              <div>
                <h4>Start at Your Location</h4>
                <p>
                  Point your phone camera at your feet and tap the ‘+’ button to
                  set your starting point.
                </p>
              </div>
            </div>
            <div className="connector"></div>

            {/* Step 2 */}
            <div className="step left">
              <img src={four} alt="Extend Line" />
              <div>
                <h4>Move Toward the Shoreline</h4>
                <p>
                  Slowly move your camera toward the waterline. The measuring
                  line will extend in real time.
                </p>
              </div>
            </div>
            <div className="connector1"></div>

            {/* Step 3 */}
            <div className="step step3">
              <img src={two} alt="Mark Waterline" />
              <div>
                <h4>Mark the Waterline</h4>
                <p>
                  Once the cursor reaches the shoreline, tap{" "}
                  <span role="img" aria-label="check">
                    ✅
                  </span>{" "}
                  to set the endpoint.
                </p>
              </div>
            </div>
            <div className="connector2"></div>

            {/* Step 4 */}
            <div className="step left">
              <img src={three} alt="View Result" />
              <div>
                <h4>View Result</h4>
                <p>
                  See your measured distance and get a status:{" "}
                  <strong>Green Zone</strong> or <strong>Red Zone</strong>.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="bg-choose">
        <section className="why-choose">
          <div className="container">
            <h2>Why Choose Shoreline Defender?</h2>
            <div className="why-choose__grid">
              <div className="feature">
                <img src={one1} alt="Interactive Map" />
                <h4>Interactive Map Integration</h4>
                <p>
                  Google Maps satellite view with pin drop, overlays, and MHWL
                  visualization offers precise, visual shoreline references.
                </p>
              </div>

              <div className="feature">
                <img src={one2} alt="Legal Safety" />
                <h4>Legal and Safety Clarity</h4>
                <p>
                  Explains MHWL significance and provides quick access to
                  reporting issues or contacting authorities for compliance and
                  safety.
                </p>
              </div>

              <div className="feature">
                <img src={one3} alt="Tidal Recalibration" />
                <h4>Real-time Tidal Recalibration</h4>
                <p>
                  Combines GPS and NOAA tide information for accurate,
                  up-to-date water levels, supporting informed decisions on the
                  beach.
                </p>
              </div>

              <div className="feature">
                <img src={one4} alt="Overlays" />
                <h4>Location-based Overlays</h4>
                <p>
                  Precise shoreline overlays and tide markers provide accurate,
                  location-specific insights for safe beach access and planning.
                </p>
              </div>

              <div className="feature">
                <img src={one5} alt="Beach Flag" />
                <h4>Beach Flag Warning System</h4>
                <p>
                  Visual warning flags quickly communicate safety conditions,
                  guiding beachgoers to avoid hazardous areas and ensure safety.
                </p>
              </div>

              <div className="feature">
                <img src={one6} alt="API" />
                <h4>Future API Integrations</h4>
                <p>
                  Upcoming API integrations will enhance data accuracy, expand
                  features, and improve user experience through seamless
                  connectivity.
                </p>
              </div>
            </div>

            {/* <div className="why-choose__cta">
              <button className="btn btn-outline">
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_485_1867)">
                      <path
                        d="M10 0.5C4.48583 0.5 0 4.98583 0 10.5C0 16.0142 4.48583 20.5 10 20.5C15.5142 20.5 20 16.0142 20 10.5C20 4.98583 15.5142 0.5 10 0.5ZM6.66667 18.1367V18C6.66667 16.1617 8.16167 14.6667 10 14.6667C11.8383 14.6667 13.3333 16.1617 13.3333 18V18.1367C12.3117 18.5842 11.185 18.8333 10 18.8333C8.815 18.8333 7.68833 18.5842 6.66667 18.1367ZM14.9375 17.2092C14.5575 14.8267 12.4883 13 10 13C7.51167 13 5.44333 14.8267 5.0625 17.2092C3.00417 15.69 1.66667 13.2483 1.66667 10.5C1.66667 5.905 5.405 2.16667 10 2.16667C14.595 2.16667 18.3333 5.905 18.3333 10.5C18.3333 13.2483 16.9958 15.69 14.9375 17.2092ZM10 4.66667C8.16167 4.66667 6.66667 6.16167 6.66667 8C6.66667 9.83833 8.16167 11.3333 10 11.3333C11.8383 11.3333 13.3333 9.83833 13.3333 8C13.3333 6.16167 11.8383 4.66667 10 4.66667ZM10 9.66667C9.08083 9.66667 8.33333 8.91917 8.33333 8C8.33333 7.08083 9.08083 6.33333 10 6.33333C10.9192 6.33333 11.6667 7.08083 11.6667 8C11.6667 8.91917 10.9192 9.66667 10 9.66667Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_485_1867">
                        <rect
                          width="20"
                          height="20"
                          fill="white"
                          transform="translate(0 0.5)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </span>
                JOIN THE MOVEMENT
              </button>
            </div> */}
          </div>
        </section>
      </div>
      <div className="container" id="about">
        <div className="shoreline-container">
          <div className="text-section">
            <h2>About Us</h2>
            <p>
              In Walton County, beachgoers have often faced uncertainty about 
              where public rights end and private property begins. 
              Some left confused. Some argued. Some just stayed quiet.
              <br />
              Until now, there was no definitive way to see where those lines are drawn.
            </p>
            <p>
              We built Shoreline Defender to bring precision to the shoreline — 
              giving residents, visitors, and property owners a clear forecast of public rights 
              and private boundaries.
            </p>

            <h2>Our Vision is simple</h2>
            <p>
              End the confusion, stop the disputes, and ensure everyone can enjoy the beach with confidence.
            </p>
            {/* <ul>
              <li> This app is built to scale.</li>
              <li> From Santa Monica to Savannah.</li>
              <li> From Key West to Cape Cod.</li>
            </ul>
            <p>
              Wherever public land is under attack,{" "}
              <strong>Shoreline Defender</strong> will show up. With truth.
            </p> */}
          </div>

          <div className="image-section">
            <img src={abouts} alt="Shoreline Defender App Preview" />
          </div>
        </div>
      </div>
      {/* <div className="discover-container">
        <h2>Discover More</h2>
        <div className="card-grid">
          {cardData.map((card, index) => (
            <div key={index} className="card">
              <div className="card-image">
                <img src={card.image} alt={card.title} />
              </div>
              <div className="card-overlay">
                <h3>{card.title}</h3>
                <a href={card.link} target="_blank">
                  {card.linkText}
                </a>
                <p>{card.description}</p>
                <div
                  className="arrow"
                  onClick={() => {
                    if (card.link) {
                      window.open(card.link, "_blank");
                    }
                  }}
                >
                  <CiLocationArrow1 size={20} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div> */}
      <div
        className="hero-banner1"
        style={{ backgroundImage: `url(${bgImage})` }}
      >
        <div className="container">
          <div className="hero-content">
            <h1>Your Shoreline, Safer Together</h1>
            <p>
              Empower Your Beach Safety. Beach Safety Made Easy. Easy access,
              impactful safety updates for everyone.
            </p>
            <div className="hero-buttons">
              <button className="primary"
              onClick={() => window.open("https://apps.apple.com/in/app/shoreline-defender-app/id6746795586", "_blank")}
              >
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_485_1860)">
                      <path
                        d="M19.1667 20.5H0.833333C0.375 20.5 0 20.125 0 19.6667C0 19.2083 0.375 18.8333 0.833333 18.8333H19.1667C19.625 18.8333 20 19.2083 20 19.6667C20 20.125 19.625 20.5 19.1667 20.5ZM12.3083 16.2167L17.6 10.5917C18.325 9.86667 18.5333 8.83333 18.1417 7.89167C17.75 6.95 16.875 6.35833 15.85 6.35H14.125L14.1 3.80833C14.1 1.98333 12.6167 0.5 10.7917 0.5H9.14167C7.31667 0.5 5.83333 1.98333 5.83333 3.81667V6.33333H4.125C3.1 6.33333 2.225 6.925 1.83333 7.875C1.44167 8.81667 1.65 9.85833 2.35833 10.5583L7.63333 16.225C8.275 16.8667 9.125 17.1917 9.975 17.1917C10.825 17.1917 11.6667 16.8667 12.3167 16.225L12.3083 16.2167ZM6.66667 8C6.89167 8 7.1 7.90833 7.25833 7.75833C7.41667 7.6 7.5 7.39167 7.5 7.16667V3.80833C7.5 2.9 8.23333 2.16667 9.14167 2.16667H10.7917C11.7 2.16667 12.4333 2.90833 12.4333 3.81667L12.4583 7.19167C12.4583 7.65 12.8333 8.01667 13.2917 8.01667H15.8333C16.3417 8.01667 16.5417 8.40833 16.5833 8.525C16.6333 8.64167 16.7667 9.05833 16.3833 9.43333L11.1083 15.0417C10.4667 15.675 9.43333 15.6667 8.81667 15.05L3.54167 9.38333C3.18333 9.025 3.31667 8.60833 3.36667 8.49167C3.41667 8.375 3.61667 7.98333 4.11667 7.98333H6.66667V8Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_485_1860">
                        <rect
                          width="20"
                          height="20"
                          fill="white"
                          transform="translate(0 0.5)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </span>{" "}
                DOWNLOAD THE APP
              </button>
              {/* <button className="secondary">
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_485_1867)">
                      <path
                        d="M10 0.5C4.48583 0.5 0 4.98583 0 10.5C0 16.0142 4.48583 20.5 10 20.5C15.5142 20.5 20 16.0142 20 10.5C20 4.98583 15.5142 0.5 10 0.5ZM6.66667 18.1367V18C6.66667 16.1617 8.16167 14.6667 10 14.6667C11.8383 14.6667 13.3333 16.1617 13.3333 18V18.1367C12.3117 18.5842 11.185 18.8333 10 18.8333C8.815 18.8333 7.68833 18.5842 6.66667 18.1367ZM14.9375 17.2092C14.5575 14.8267 12.4883 13 10 13C7.51167 13 5.44333 14.8267 5.0625 17.2092C3.00417 15.69 1.66667 13.2483 1.66667 10.5C1.66667 5.905 5.405 2.16667 10 2.16667C14.595 2.16667 18.3333 5.905 18.3333 10.5C18.3333 13.2483 16.9958 15.69 14.9375 17.2092ZM10 4.66667C8.16167 4.66667 6.66667 6.16167 6.66667 8C6.66667 9.83833 8.16167 11.3333 10 11.3333C11.8383 11.3333 13.3333 9.83833 13.3333 8C13.3333 6.16167 11.8383 4.66667 10 4.66667ZM10 9.66667C9.08083 9.66667 8.33333 8.91917 8.33333 8C8.33333 7.08083 9.08083 6.33333 10 6.33333C10.9192 6.33333 11.6667 7.08083 11.6667 8C11.6667 8.91917 10.9192 9.66667 10 9.66667Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_485_1867">
                        <rect
                          width="20"
                          height="20"
                          fill="white"
                          transform="translate(0 0.5)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </span>{" "}
                JOIN THE MOVEMENT
              </button> */}
            </div>
          </div>
        </div>
      </div>
      <div className="faq-container">
        <h2>Have a Question?</h2>
        <div className="faq-list">
          {faqData.map((item, index) => (
            <div
              key={index}
              className={`faq-item ${activeIndex === index ? "active" : ""}`}
              onClick={() => toggleFAQ(index)}
            >
              <div className="faq-question">
                <span>{activeIndex === index ? "−" : "+"}</span>
                <h4>{item.question}</h4>
              </div>
              {activeIndex === index && (
                <p className="faq-answer">{item.answer}</p>
              )}
            </div>
          ))}
        </div>
      </div>
      {/* <div className="newsletter-section">
        <div className="content">
          <h2>Subscribe to our newsletter</h2>
          <p>Never miss out on what matters to you.</p>
          <form>
            <input type="email" placeholder="Email Address" required />
            <button type="submit">📧 SUBSCRIBE</button>
          </form>
        </div>
        <div className="image" style={{ backgroundImage: `url(${sub})` }} />
      </div> */}
      <footer className="footer">
        <div className="container">
          <div className="footer-top">
            <div className="brand">
              <img src={logo} alt="Shoreline Defender Logo" />
              {/* <div className="social-icons">
                <a>
                  <FaFacebookF size={15} />
                </a>
                <a>
                  <FaInstagram size={15} />
                </a>
                <a>
                  <FaLinkedinIn size={15} />
                </a>
                <a>
                  <FaYoutube size={15} />
                </a>
              </div> */}

              <div className="store-btns">
                <a
                  href="https://apps.apple.com/in/app/shoreline-defender-app/id6746795586"
                  className="btn store-btn app-store"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="30"
                      height="30"
                      fill="currentColor"
                      class="bi bi-apple shake"
                      viewBox="0 0 20 20"
                      data-sentry-element="svg"
                      data-sentry-component="AppleIcon"
                      data-sentry-source-file="icons.tsx"
                    >
                      <path
                        d="M11.182.008C11.148-.03 9.923.023 8.857 1.18c-1.066 1.156-.902 2.482-.878 2.516s1.52.087 2.475-1.258.762-2.391.728-2.43m3.314 11.733c-.048-.096-2.325-1.234-2.113-3.422s1.675-2.789 1.698-2.854-.597-.79-1.254-1.157a3.7 3.7 0 0 0-1.563-.434c-.108-.003-.483-.095-1.254.116-.508.139-1.653.589-1.968.607-.316.018-1.256-.522-2.267-.665-.647-.125-1.333.131-1.824.328-.49.196-1.422.754-2.074 2.237-.652 1.482-.311 3.83-.067 4.56s.625 1.924 1.273 2.796c.576.984 1.34 1.667 1.659 1.899s1.219.386 1.843.067c.502-.308 1.408-.485 1.766-.472.357.013 1.061.154 1.782.539.571.197 1.111.115 1.652-.105.541-.221 1.324-1.059 2.238-2.758q.52-1.185.473-1.282"
                        data-sentry-element="path"
                        data-sentry-source-file="icons.tsx"
                      ></path>
                      <path
                        d="M11.182.008C11.148-.03 9.923.023 8.857 1.18c-1.066 1.156-.902 2.482-.878 2.516s1.52.087 2.475-1.258.762-2.391.728-2.43m3.314 11.733c-.048-.096-2.325-1.234-2.113-3.422s1.675-2.789 1.698-2.854-.597-.79-1.254-1.157a3.7 3.7 0 0 0-1.563-.434c-.108-.003-.483-.095-1.254.116-.508.139-1.653.589-1.968.607-.316.018-1.256-.522-2.267-.665-.647-.125-1.333.131-1.824.328-.49.196-1.422.754-2.074 2.237-.652 1.482-.311 3.83-.067 4.56s.625 1.924 1.273 2.796c.576.984 1.34 1.667 1.659 1.899s1.219.386 1.843.067c.502-.308 1.408-.485 1.766-.472.357.013 1.061.154 1.782.539.571.197 1.111.115 1.652-.105.541-.221 1.324-1.059 2.238-2.758q.52-1.185.473-1.282"
                        data-sentry-element="path"
                        data-sentry-source-file="icons.tsx"
                      ></path>
                    </svg>
                  </span>
                  <span className="text">
                    <small>Download on the</small>
                    <strong>App Store</strong>
                  </span>
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.shoreline.defender.app"
                  className="btn store-btn play-store"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="30"
                      height="30"
                      fill="currentColor"
                      class="bi bi-google-play shake"
                      viewBox="0 0 20 20"
                      data-sentry-element="svg"
                      data-sentry-component="AndroidIcon"
                      data-sentry-source-file="icons.tsx"
                    >
                      <path
                        d="M14.222 9.374c1.037-.61 1.037-2.137 0-2.748L11.528 5.04 8.32 8l3.207 2.96zm-3.595 2.116L7.583 8.68 1.03 14.73c.201 1.029 1.36 1.61 2.303 1.055zM1 13.396V2.603L6.846 8zM1.03 1.27l6.553 6.05 3.044-2.81L3.333.215C2.39-.341 1.231.24 1.03 1.27"
                        data-sentry-element="path"
                        data-sentry-source-file="icons.tsx"
                      ></path>
                    </svg>
                  </span>
                  <span className="text">
                    <small>Get it on</small>
                    <strong>Google Play</strong>
                  </span>
                </a>
              </div>
            </div>

            <div className="footer-links">
              <div>
                <h4>Links</h4>
                <ul>
                  <li>
                    <a href="#home">Home</a>
                  </li>
                  <li>
                    <a href="#how-it-works">How It Works</a>
                  </li>
                  <li>
                    <a href="#about">About</a>
                  </li>
                  {/* <li>
                    <a>Report a Dispute</a>
                  </li>
                  <li>
                    <a>Advocacy</a>
                  </li> */}
                  <li>
                    <a href="https://www.visitsouthwalton.com/beach-safety/">
                      Beach Safety
                    </a>
                  </li>
                </ul>
              </div>
              {/* <div>
                <h4>Information</h4>
                <ul>
                  <li>
                    <a>Beach Flags</a>
                  </li>
                  <li>
                    <a>Rip Currents</a>
                  </li>
                  <li>
                    <a>Sea Turtles</a>
                  </li>
                  <li>
                    <a>Beach Rules</a>
                  </li>
                  <li>
                    <a>Emergency Contacts</a>
                  </li>
                  <li>
                    <a>Disclaimer</a>
                  </li>
                </ul>
              </div> */}
              <div>
                <h4>Contact</h4>
                <address>
                  Shoreline Defender LLC
                  <br />
                  1309 Coffeen Ave, Coffeen Avenue,
                  <br />
                  Sheridan, WY, USA
                  <br />
                  <br />
                  Let's Discuss
                  <br />
                  (307) 683-0983
                  <br />
                  <br />
                  Mon–Fri
                  <br />
                  09:00 am – 05:00 pm
                </address>
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <div>
              <a href='/terms'>Terms of Use</a> · <a href='/privacy'>Privacy Policy</a>
            </div>
            <div>© 2025 Shoreline Defender. All Rights Reserved.</div>
          </div>
        </div>
      </footer>
    </div>
  );
}
